export default __webpack_public_path__ + "assets/addfd6ef7f06815eeb477b651f95bdd9.svg";